import { createSlice } from "@reduxjs/toolkit";

interface ScheduledQualificationsPageInterface {
    currentPage: number;
    itemsPerPage: number;
    searchTerm: string;
    itemsPerPageSelect: { value: number; activeValue: boolean }[];
    isDeleteScheduledQualificationModalOpen: boolean;
    scheduledQualificationId?: number;
    sort: {
        sortName: string;
        isSorted: boolean;
    };
}

const initialState: ScheduledQualificationsPageInterface = {
    currentPage: 1,
    itemsPerPage: 12,
    searchTerm: "",
    itemsPerPageSelect: [
        { value: 12, activeValue: true },
        { value: 25, activeValue: false },
        { value: 50, activeValue: false },
    ],
    isDeleteScheduledQualificationModalOpen: false,
    sort: {
        sortName: "",
        isSorted: false,
    },
};

const scheduledQualificationSlice = createSlice({
    name: "scheduledQualificationSlice",
    initialState,
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setItemsPerPage: (state, action) => {
            state.itemsPerPage = action.payload;

            state.itemsPerPageSelect = state.itemsPerPageSelect.map((item) => {
                return {
                    ...item,
                    activeValue: item.value === action.payload,
                };
            });
        },
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
        },
        setIsDeleteScheduledQualificationModalOpen: (state, action) => {
            state.isDeleteScheduledQualificationModalOpen = action.payload;
        },
        setScheduledQualificationId: (state, action) => {
            state.scheduledQualificationId = action.payload;
        },
        setSort: (state, action) => {
            state.sort = action.payload;
        },
    },
});

export const scheduledQualificationsReducer =
    scheduledQualificationSlice.reducer;

export const {
    setItemsPerPage,
    setCurrentPage,
    setSearchTerm,
    setIsDeleteScheduledQualificationModalOpen,
    setScheduledQualificationId,
    setSort,
} = scheduledQualificationSlice.actions;
